function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M386.73,145.24S354.5,102.05,301,99s-83.34,33.45-105.24,60.83-88.2,11.55-128.35,53.53-20.68,66.3-3,90.63S99,332,99,352.06s9.74,46.84,48.06,52.92,77.86-31,105.23-17,73.3,24.94,101.44,17,19.61-37.11,50-46.84,59.61-40.15,55.35-73-28.59-38.93-38.93-70.56S395.25,158.62,386.73,145.24Z",
  fill: "#91C788"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M386.73,145.24S354.5,102.05,301,99s-83.34,33.45-105.24,60.83-88.2,11.55-128.35,53.53-20.68,66.3-3,90.63S99,332,99,352.06s9.74,46.84,48.06,52.92,77.86-31,105.23-17,73.3,24.94,101.44,17,19.61-37.11,50-46.84,59.61-40.15,55.35-73-28.59-38.93-38.93-70.56S395.25,158.62,386.73,145.24Z",
  fill: "#fff",
  opacity: 0.7
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m423.38 411.82c0 1.77-56 3.2-125 3.2s-125-1.43-125-3.2 56-3.19 125-3.19 125 1.43 125 3.19z",
  fill: "#2e353a"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 200.41,
  y: 115.25,
  width: 130.69,
  height: 59.15,
  rx: 6.62,
  fill: "#91C788"
});

var _ref6 = /*#__PURE__*/React.createElement("polyline", {
  points: "200.41 164 200.41 185.35 212.32 171.64",
  fill: "#91C788"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "m324.49 115.25h-117.49a6.61 6.61 0 0 0-6.61 6.62v63.48l9.52-10.95h114.58a6.61 6.61 0 0 0 6.61-6.62v-45.91a6.61 6.61 0 0 0-6.61-6.62z",
  fill: "#91C788"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "m324.49 115.25h-117.49a6.61 6.61 0 0 0-6.61 6.62v63.48l9.52-10.95h114.58a6.61 6.61 0 0 0 6.61-6.62v-45.91a6.61 6.61 0 0 0-6.61-6.62z",
  fill: "#91C788",
  opacity: 0.1
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "m301 147.7h-84.39a2.36 2.36 0 0 1-2.36-2.36 2.36 2.36 0 0 1 2.36-2.35h84.39a2.36 2.36 0 0 1 2.36 2.35 2.36 2.36 0 0 1-2.36 2.36z",
  fill: "#fff"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "m301 158.54h-84.39a2.36 2.36 0 0 1-2.36-2.36 2.36 2.36 0 0 1 2.36-2.35h84.39a2.36 2.36 0 0 1 2.36 2.35 2.36 2.36 0 0 1-2.36 2.36z",
  fill: "#fff"
});

var _ref11 = /*#__PURE__*/React.createElement("circle", {
  cx: 221.32,
  cy: 128.38,
  r: 8.48,
  fill: "#fff"
});

var _ref12 = /*#__PURE__*/React.createElement("rect", {
  x: 200.41,
  y: 195.3,
  width: 130.69,
  height: 59.15,
  rx: 6.62,
  fill: "#91C788"
});

var _ref13 = /*#__PURE__*/React.createElement("polyline", {
  points: "200.41 244.04 200.41 265.4 212.32 251.68",
  fill: "#91C788"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M324.49,195.3H207a6.61,6.61,0,0,0-6.61,6.61V265.4l9.52-11H324.49a6.61,6.61,0,0,0,6.61-6.61V201.91A6.61,6.61,0,0,0,324.49,195.3Z",
  fill: "#91C788"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M324.49,195.3H207a6.61,6.61,0,0,0-6.61,6.61V265.4l9.52-11H324.49a6.61,6.61,0,0,0,6.61-6.61V201.91A6.61,6.61,0,0,0,324.49,195.3Z",
  fill: "#91C788",
  opacity: 0.1
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "m301 227.74h-84.39a2.36 2.36 0 0 1-2.36-2.35 2.36 2.36 0 0 1 2.36-2.36h84.39a2.36 2.36 0 0 1 2.36 2.36 2.36 2.36 0 0 1-2.36 2.35z",
  fill: "#fff"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "m301 238.58h-84.39a2.36 2.36 0 0 1-2.36-2.35 2.36 2.36 0 0 1 2.36-2.36h84.39a2.36 2.36 0 0 1 2.36 2.36 2.36 2.36 0 0 1-2.36 2.35z",
  fill: "#fff"
});

var _ref18 = /*#__PURE__*/React.createElement("circle", {
  cx: 221.32,
  cy: 208.42,
  r: 8.48,
  fill: "#fff"
});

var _ref19 = /*#__PURE__*/React.createElement("g", {
  fill: "#2e353a"
}, /*#__PURE__*/React.createElement("path", {
  d: "m109.65 312.5c-0.09 0-0.49-6.27-0.47-6.67 0.23-4.63 3.41-13.45 8.44-14.79a6.14 6.14 0 0 1 7.52 5.21c0.58 3.62-1.78 7.48-4.17 10-2.82 2.92-11.32 6.25-11.32 6.25z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m103.09 288.34c-0.09 0 0.46-6.26 0.54-6.66 0.94-4.54 5.42-12.78 10.58-13.34a6.15 6.15 0 0 1 6.65 6.29c0 3.67-2.89 7.13-5.63 9.24-3.23 2.48-12.14 4.47-12.14 4.47z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m101.43 259.83c-0.09 0 0.47-6.26 0.55-6.66 0.93-4.54 5.41-12.78 10.58-13.34a6.14 6.14 0 0 1 6.64 6.29c0 3.67-2.88 7.12-5.63 9.24-3.23 2.48-12.13 4.47-12.14 4.47z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M98.56,233c-.09,0,.47-6.27.55-6.66.93-4.55,5.41-12.78,10.58-13.35a6.15,6.15,0,0,1,6.64,6.3c0,3.66-2.88,7.12-5.63,9.23C107.47,231,98.57,233,98.56,233Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M90,211.47c-.08,0-1.2-6.17-1.23-6.57-.3-4.63,1.85-13.76,6.68-15.66a6.14,6.14,0,0,1,8.07,4.31c1,3.53-.9,7.63-3,10.39C98.08,207.19,90,211.47,90,211.47Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M107,312.57c.1,0-2.63-5.71-2.85-6.05-2.47-3.92-9.56-10.06-14.59-8.77a6.14,6.14,0,0,0-4,8.22c1.26,3.45,5.2,5.66,8.52,6.67C98,313.83,107,312.57,107,312.57Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m101.75 285.11c0.1 0-3.47-5.24-3.73-5.54-3-3.51-11-8.5-15.75-6.47a6.14 6.14 0 0 0-2.72 8.74c1.76 3.21 6 4.8 9.43 5.3 4.02 0.58 12.77-2.03 12.77-2.03z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m100.24 258.21c0.09 0-3.47-5.24-3.73-5.54-3-3.51-11-8.5-15.76-6.46a6.15 6.15 0 0 0-2.75 8.79c1.77 3.21 6 4.8 9.44 5.29 4.05 0.54 12.8-2.07 12.8-2.08z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m97.65 233.53c0.1 0-3.47-5.24-3.73-5.54-3-3.51-11-8.5-15.75-6.47a6.14 6.14 0 0 0-2.72 8.74c1.76 3.22 6 4.8 9.43 5.3 4.02 0.58 12.77-2.03 12.77-2.03z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m90.06 212.28c0.09 0-4-4.82-4.32-5.1-3.4-3.15-11.84-7.24-16.37-4.69a6.14 6.14 0 0 0-1.74 9c2.11 3 6.49 4.12 10 4.23 4.02 0.12 12.43-3.43 12.43-3.44z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m79.15 194.72c0.09 0-1.35-6.14-1.48-6.52-1.57-4.37-7.17-11.88-12.37-11.71a6.15 6.15 0 0 0-5.69 7.17c0.5 3.64 3.87 6.64 6.89 8.34 3.55 2 12.64 2.72 12.65 2.72z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M118.39,344.9s-1.07-2.45-2.75-6.74-4-10.48-6.46-18c-1.23-3.76-2.48-7.86-3.7-12.23-.62-2.2-1.18-4.41-1.79-6.78-.26-1.16-.51-2.33-.77-3.51s-.44-2.43-.66-3.66a139,139,0,0,1-1.53-15.23c-.25-5.19-.35-10.44-.48-15.69s-.26-10.48-.68-15.6a107.25,107.25,0,0,0-2.15-14.91A79,79,0,0,0,93,219.19a108.5,108.5,0,0,0-5.67-11.32c-1.93-3.43-3.91-6.44-5.68-9.1s-3.43-4.9-4.82-6.73c-2.78-3.66-4.52-5.62-4.52-5.62s1.78,1.93,4.65,5.52c1.42,1.81,3.12,4,5,6.64s3.88,5.6,5.89,9a110.07,110.07,0,0,1,6,11.27,81,81,0,0,1,4.81,13.42,108.38,108.38,0,0,1,2.51,15c.53,5.17.8,10.43,1,15.68s.45,10.48.81,15.61a138.92,138.92,0,0,0,1.82,14.92c.25,1.19.4,2.35.71,3.53s.57,2.34.85,3.49c.62,2.19,1.25,4.47,1.91,6.6,1.29,4.29,2.62,8.32,3.92,12,2.58,7.4,5,13.46,6.77,17.68s2.86,6.56,2.86,6.56a1.83,1.83,0,0,1-3.31,1.54l0,0Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m141.94 306.14c-0.09 0 1.32-6.15 1.45-6.53 1.54-4.37 7.1-11.92 12.29-11.78a6.14 6.14 0 0 1 5.73 7.13c-0.47 3.64-3.82 6.67-6.83 8.39-3.58 2.02-12.58 2.79-12.64 2.79z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m142.52 281.12c-0.09 0 2.23-5.88 2.42-6.23 2.19-4.1 8.82-10.72 13.93-9.79a6.15 6.15 0 0 1 4.59 7.92c-1 3.53-4.79 6-8 7.25-3.83 1.46-12.93 0.85-12.94 0.85z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m149 253.31c-0.1 0 2.22-5.88 2.41-6.23 2.19-4.09 8.83-10.71 13.94-9.79a6.15 6.15 0 0 1 4.58 7.93c-1 3.52-4.79 6-8 7.25-3.78 1.46-12.93 0.84-12.93 0.84z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m153.91 226.78c-0.1 0 2.22-5.87 2.41-6.23 2.19-4.09 8.83-10.71 13.94-9.78a6.14 6.14 0 0 1 4.58 7.92c-1 3.53-4.79 6-8 7.25-3.84 1.46-12.93 0.84-12.93 0.84z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m151.84 203.69c-0.1 0 0.59-6.25 0.68-6.64 1-4.53 5.68-12.67 10.86-13.12a6.15 6.15 0 0 1 6.51 6.43c0 3.67-3 7.06-5.82 9.11-3.28 2.41-12.23 4.22-12.23 4.22z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m139.42 305.46c0.09 0-0.91-6.22-1-6.6-1.25-4.47-6.3-12.37-11.49-12.57a6.15 6.15 0 0 0-6.19 6.75c0.23 3.66 3.38 6.9 6.27 8.81 3.38 2.25 12.4 3.61 12.41 3.61z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m142.16 277.64c0.1 0-1.84-6-2-6.38-1.92-4.23-8.11-11.27-13.27-10.68a6.15 6.15 0 0 0-5.09 7.61c0.78 3.58 4.39 6.31 7.53 7.76 3.67 1.71 12.82 1.69 12.83 1.69z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m148.36 251.42c0.09 0-1.84-6-2-6.38-1.91-4.22-8.1-11.26-13.26-10.67a6.15 6.15 0 0 0-5.1 7.63c0.79 3.59 4.39 6.31 7.54 7.76 3.69 1.68 12.81 1.66 12.82 1.66z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M152.89,227c.1,0-1.84-6-2-6.38-1.92-4.22-8.1-11.27-13.27-10.67a6.14,6.14,0,0,0-5.09,7.6c.78,3.59,4.39,6.31,7.54,7.76C143.76,227,152.89,227,152.89,227Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m151.65 204.49c0.1 0-2.48-5.77-2.69-6.12-2.37-4-9.29-10.31-14.36-9.15a6.14 6.14 0 0 0-4.22 8.12c1.17 3.47 5.05 5.78 8.34 6.88 3.86 1.29 12.93 0.27 12.93 0.27z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m146.19 184.55c0.08 0 0.45-6.27 0.42-6.67-0.26-4.64-3.49-13.44-8.52-14.75a6.15 6.15 0 0 0-7.49 5.26c-0.56 3.63 1.82 7.47 4.23 10 2.83 2.88 11.35 6.15 11.36 6.16z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M141.12,339.69s-.34-2.65-.73-7.25-.86-11.18-1.07-19.09c-.11-4-.15-8.24-.07-12.78,0-2.28.12-4.56.21-7,.08-1.18.17-2.38.25-3.58s.28-2.46.41-3.7a141.27,141.27,0,0,1,2.87-15c1.23-5.05,2.63-10.12,4-15.18s2.72-10.12,3.78-15.16a106.67,106.67,0,0,0,2.17-14.9,79.32,79.32,0,0,0-.48-14.07,107.38,107.38,0,0,0-2.22-12.47c-.88-3.84-1.91-7.29-2.85-10.34s-1.91-5.68-2.71-7.82c-1.63-4.3-2.74-6.68-2.74-6.68s1.16,2.36,2.88,6.62c.86,2.13,1.85,4.74,2.89,7.77s2.12,6.48,3.08,10.31a109.06,109.06,0,0,1,2.51,12.5,80.36,80.36,0,0,1,.8,14.24,108.46,108.46,0,0,1-1.87,15.14c-1,5.1-2.2,10.22-3.47,15.32s-2.55,10.18-3.66,15.2a137.76,137.76,0,0,0-2.5,14.82c-.1,1.21-.28,2.36-.32,3.58s-.12,2.41-.18,3.59c0,2.28-.07,4.64,0,6.87,0,4.49.15,8.73.35,12.64.37,7.83,1,14.34,1.47,18.87s.87,7.11.87,7.11a1.82,1.82,0,0,1-3.61.53v-.05Z"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "152.72 405.81 110.38 405.81 98.47 336.47 164.63 336.47"
}));

var _ref20 = /*#__PURE__*/React.createElement("circle", {
  cx: 227.3,
  cy: 320.3,
  r: 92.07,
  fill: "#91C788"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "m227.3 412.83a92.53 92.53 0 1 1 92.53-92.53 92.64 92.64 0 0 1-92.53 92.53zm0-184.15a91.62 91.62 0 1 0 91.62 91.62 91.71 91.71 0 0 0-91.62-91.62z",
  fill: "#2e353a"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M202.91,380.85a62.55,62.55,0,0,1-21-12.93,57.58,57.58,0,0,1-13.9-21A74.92,74.92,0,0,1,163,319a66.25,66.25,0,0,1,4.24-23.86,59.56,59.56,0,0,1,11.45-19,76.34,76.34,0,0,1,36.62-22.29,82,82,0,0,1,21.19-2.8,72.74,72.74,0,0,1,17.62,2.1,57.32,57.32,0,0,1,15.82,6.55,52.57,52.57,0,0,1,12.89,10.93,47.64,47.64,0,0,1,8.65,15.69,62.24,62.24,0,0,1,3.15,20.23,56.17,56.17,0,0,1-13.37,36.06,49.21,49.21,0,0,1-13,10.53A28.63,28.63,0,0,1,254.39,357a15.37,15.37,0,0,1-9.31-3,10.81,10.81,0,0,1-4.41-8.66q-8.56,12.06-23.16,12.06-11.89,0-19-8.13t-7.08-20a52.93,52.93,0,0,1,3.1-17.66,59.84,59.84,0,0,1,8.44-16,41.77,41.77,0,0,1,13.41-11.67,34.8,34.8,0,0,1,17.18-4.5,25,25,0,0,1,12,2.93,19.69,19.69,0,0,1,8.35,8.52l.78-2.54a7.14,7.14,0,0,1,11-3.49,4.75,4.75,0,0,1,1.74,3.93,6.43,6.43,0,0,1-.35,2.1l-12.41,41.25q-2.1,7.08-2.1,9.71,0,4.46,4.55,4.45,5.94,0,11.67-5.46a40.21,40.21,0,0,0,9.31-14.51,50.44,50.44,0,0,0,3.58-18.75,54.27,54.27,0,0,0-2.45-16.69A40.3,40.3,0,0,0,272.66,278a39.47,39.47,0,0,0-10-8.92,43.8,43.8,0,0,0-12.33-5.33A54.12,54.12,0,0,0,236.65,262a63.22,63.22,0,0,0-17.35,2.45,62.27,62.27,0,0,0-16.39,7.39,64.09,64.09,0,0,0-13.77,11.71,51.57,51.57,0,0,0-9.52,16.21A57.08,57.08,0,0,0,176.08,320a62.2,62.2,0,0,0,4.37,23.91,45.2,45.2,0,0,0,11.93,17.22,53.55,53.55,0,0,0,17.3,10.09,61.09,61.09,0,0,0,20.85,3.5,74.28,74.28,0,0,0,22.38-3.41,6.68,6.68,0,0,1,2.27-.35,5.08,5.08,0,0,1,3.93,1.62,5.33,5.33,0,0,1,1.49,3.71,4.62,4.62,0,0,1-3.59,4.9,97.89,97.89,0,0,1-27.88,4.28A73.59,73.59,0,0,1,202.91,380.85Zm31.6-39.68a21.82,21.82,0,0,0,8-11l8-28.14-.53-1.14a13.75,13.75,0,0,0-1.83-2.58,28.27,28.27,0,0,0-3.11-3.06,15.42,15.42,0,0,0-4.8-2.62,19,19,0,0,0-13.9.48,22.91,22.91,0,0,0-6.51,4.24,35.46,35.46,0,0,0-5.29,6.21,41.39,41.39,0,0,0-4,7.47,46,46,0,0,0-2.49,8.08,38.4,38.4,0,0,0-.88,8,39.11,39.11,0,0,0,.31,5.16,23.22,23.22,0,0,0,1,4.46,15,15,0,0,0,1.79,3.71,10.89,10.89,0,0,0,2.62,2.75,11.14,11.14,0,0,0,3.63,1.75,16.72,16.72,0,0,0,4.72.61A21.59,21.59,0,0,0,234.51,341.17Z",
  fill: "#2e353a"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M352.51,242.87s-3,5.58-3.44,6.36-2.05,5-1.57,6,.94,1.57,1.89,1.73,1.73,1.89,3.3,2.2a16.91,16.91,0,0,0,3,.32,2,2,0,0,0,1.74.31c.94-.31,1.73-.78,2.36-3.46a10,10,0,0,0,.31-4.09l-.28-5.41Z",
  fill: "#fff"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M356.87,260.37a2.56,2.56,0,0,1-1.34-.4,17.49,17.49,0,0,1-2.94-.33,4.66,4.66,0,0,1-2.31-1.46,2.65,2.65,0,0,0-1-.74,3.1,3.1,0,0,1-2.25-2c-.65-1.29,1.24-5.88,1.59-6.46.46-.77,3.4-6.29,3.43-6.35a.52.52,0,0,1,.3-.24.51.51,0,0,1,.38,0l7.3,3.95a.52.52,0,0,1,.26.42l.28,5.4h0a10.36,10.36,0,0,1-.33,4.23c-.62,2.67-1.43,3.41-2.69,3.83A2.22,2.22,0,0,1,356.87,260.37Zm-4.15-16.82c-.72,1.34-2.82,5.27-3.22,5.94-.55.91-1.87,4.88-1.56,5.5.5,1,.88,1.36,1.53,1.47a3.09,3.09,0,0,1,1.51,1,3.76,3.76,0,0,0,1.81,1.2,17.25,17.25,0,0,0,2.89.31.52.52,0,0,1,.32.11,1.48,1.48,0,0,0,1.26.23c.69-.23,1.41-.47,2-3.1a9.75,9.75,0,0,0,.31-3.88l-.27-5.2Z",
  fill: "#2e353a"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M369.85,393.12s-4.27,6.95-4.27,8.63,5.88,4.77,8.4,5.89,7,2,10.64,2.52,11.2,2,9-.84S377.9,399,377.34,398.11a15.75,15.75,0,0,0-2.32-2.26Z",
  fill: "#fff"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M391.8,411.5a45.34,45.34,0,0,1-6.36-.71l-.9-.14c-5.08-.78-8.7-1.64-10.76-2.56-.36-.16-8.7-3.89-8.7-6.34,0-1.77,3.9-8.17,4.34-8.9a.51.51,0,0,1,.66-.18l5.17,2.74a15.07,15.07,0,0,1,2.51,2.43c.24.28,2.44,1.66,4.57,3,4.54,2.83,10.18,6.36,11.64,8.18.53.66.66,1.23.38,1.7S393.19,411.5,391.8,411.5ZM370,393.78c-1.62,2.68-3.95,6.91-3.95,8s4.28,3.73,8.1,5.43c2,.88,5.52,1.71,10.52,2.48l.89.14c1.84.29,7.44,1.18,7.9.4,0,0,0-.2-.3-.57-1.35-1.69-7.15-5.32-11.39-8-3.41-2.13-4.63-2.91-4.88-3.28a14.89,14.89,0,0,0-2.22-2.15Z",
  fill: "#2e353a"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "m376.54 404.07 1.5 2.24a17.85 17.85 0 0 0 6.38 5.86c4 2.16 10.16 4.63 15.54 3.15 8.82-2.43-13.38-15.82-13.38-15.82s-7.91 5.5-10.04 4.57z",
  fill: "#fff"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M396.46,416.27c-4.44,0-9-1.86-12.28-3.66a18.43,18.43,0,0,1-6.56-6l-1.5-2.25a.5.5,0,0,1,0-.59.51.51,0,0,1,.59-.14c1.29.56,6.36-2.31,9.55-4.52a.48.48,0,0,1,.54,0c1.67,1,16.31,10,15.68,14.56-.14,1-1,1.76-2.42,2.16A13.55,13.55,0,0,1,396.46,416.27Zm-18.94-11.64.93,1.41a17.48,17.48,0,0,0,6.2,5.69c4.08,2.2,10,4.53,15.18,3.11,1.56-.44,1.66-1.12,1.69-1.34.45-3.27-10.37-10.62-14.93-13.4C385,401.16,380.22,404.31,377.52,404.63Z",
  fill: "#2e353a"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M379.08,405.13a18.19,18.19,0,0,0,10.36,7.51c7.25,2.07,9.33,1.55,10.88-.52",
  fill: "#fff"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M396.36,414.46a27.4,27.4,0,0,1-7.05-1.34,18.49,18.49,0,0,1-10.66-7.74.49.49,0,0,1,.18-.68.51.51,0,0,1,.69.18,17.9,17.9,0,0,0,10.06,7.28c7.07,2,9,1.5,10.34-.34a.51.51,0,0,1,.7-.1.5.5,0,0,1,.1.7A4.9,4.9,0,0,1,396.36,414.46Z",
  fill: "#2e353a"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "m366.13 400.47s8 5.73 11.91 5.84",
  fill: "#fff"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M378,406.81h0c-4-.11-11.85-5.7-12.18-5.93a.51.51,0,0,1-.11-.7.49.49,0,0,1,.69-.12c.08.06,7.93,5.65,11.63,5.75a.51.51,0,0,1,.49.52A.5.5,0,0,1,378,406.81Z",
  fill: "#2e353a"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M348.76,244.79s7.1,11.77,8.62,14.5,20.68,24.64,28.28,43.5,14.91,35.88,14.6,41.36S375,395.85,375,395.85l-5.17-2.73s7.9-43.5,7-48.06S348,295.18,348,295.18s-13.08-9.12-18.55-19.77",
  fill: "#2e353a"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M349.77,274.2s-3.95,8.51-3.95,9.73,22.2,66.61,28.59,81.51a302.48,302.48,0,0,1,10.64,29.2s2.44,3,.61,6.08-9.12,5.17-10.64,2.43-16.43-17-22.81-31.32-15.51-38.63-20.69-47.75a326.65,326.65,0,0,1-18.24-36.2c-6.7-15.81-13.59-32.95-13.59-32.95a69.48,69.48,0,0,0,26.76-3c14-4.56,20-13.29,20-13.29s3.56,9.1,4.47,10.86",
  fill: "#2e353a"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M351.86,299.88a.35.35,0,0,1-.32-.22l-7-18.2a.36.36,0,0,1,.1-.39l7.84-6.72a.36.36,0,0,1,.49,0,.35.35,0,0,1,0,.48l-7.66,6.57,6.91,18a.35.35,0,0,1-.19.45Z",
  fill: "#fff"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M344.85,281.67a.33.33,0,0,1-.23-.09.34.34,0,0,1-.11-.25c0-.05,0-5.54-2.46-9-.61-.89-1.1-1.59-1.51-2.16-1.28-1.82-1.67-2.37-1.9-3.28a10.89,10.89,0,0,1,0-3.21.36.36,0,0,1,.39-.29.34.34,0,0,1,.29.39,10.33,10.33,0,0,0,0,2.95c.2.78.54,1.26,1.8,3.05.4.57.9,1.27,1.51,2.16,2.22,3.19,2.53,7.77,2.58,9.08l14.21-.55a.36.36,0,0,1,.36.33.33.33,0,0,1-.33.35l-14.56.56Z",
  fill: "#fff"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M392.47,346.41c-6.33,0-14.37-4.1-14.73-4.28a.34.34,0,0,1-.14-.46.34.34,0,0,1,.46-.15c.09.05,9.23,4.71,15.49,4.16a.34.34,0,0,1,.37.32.34.34,0,0,1-.31.37C393.24,346.4,392.86,346.41,392.47,346.41Z",
  fill: "#fff"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M391.62,351.69h-.08c-5.61-1.41-11.91-6.57-12.18-6.79a.35.35,0,0,1,0-.48.34.34,0,0,1,.48-.05c.06.05,6.45,5.29,11.91,6.65a.34.34,0,0,1,.24.42A.33.33,0,0,1,391.62,351.69Z",
  fill: "#fff"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "M344.57,276.35a.35.35,0,0,1-.28-.14.34.34,0,0,1,.09-.48c1.35-.94,3.49-2.75,3.49-3.64,0-.59-.73-1.29-1.51-2a8.6,8.6,0,0,1-2.1-2.6c-.51-1.19-2.34-5.86-2-7a.34.34,0,0,1,.43-.22.35.35,0,0,1,.22.44c-.21.61.88,4,1.95,6.48a8,8,0,0,0,1.94,2.36c.93.89,1.73,1.65,1.73,2.53,0,1.54-3.4,3.93-3.79,4.2A.36.36,0,0,1,344.57,276.35Z",
  fill: "#fff"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  d: "M311.25,278.31a.34.34,0,0,1-.22-.61l2.8-2.24c2.69-2.14,4.35-7.61,4.37-7.67a.35.35,0,0,1,.43-.23.35.35,0,0,1,.23.43c-.07.23-1.75,5.73-4.6,8l-2.8,2.24A.33.33,0,0,1,311.25,278.31Z",
  fill: "#fff"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  d: "M377.73,404.51a.35.35,0,0,1-.26-.13,109.2,109.2,0,0,1-9.67-13.94c-3.87-6.92-15-25.85-15.12-26a32.56,32.56,0,0,1-2.28-7.12c-.07-.38-.12-.73-.17-1-.37-2.52-.53-3.56-3.88-5.72s-3.56-5.92-3.84-9.95c-.06-.95-.13-1.93-.24-2.9-.45-4-11.07-22-18.82-35.08-1.76-3-3.36-5.68-4.66-7.91-6.94-11.94-11.74-27.64-11.79-27.8a.35.35,0,0,1,.23-.43.33.33,0,0,1,.42.23c.05.16,4.83,15.79,11.73,27.65,1.3,2.23,2.9,4.94,4.66,7.91,7.79,13.15,18.45,31.17,18.91,35.35.11,1,.18,2,.25,2.94.27,4,.5,7.48,3.52,9.42,3.61,2.32,3.79,3.53,4.19,6.18,0,.33.1.67.16,1.05a31.92,31.92,0,0,0,2.22,6.91c.09.17,11.23,19.1,15.11,26A109.05,109.05,0,0,0,378,404a.34.34,0,0,1-.05.48A.35.35,0,0,1,377.73,404.51Z",
  fill: "#fff"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  d: "m299.69 254.93s0.64 7.08 3.44 9.32 11.2 4.2 22.68 2 24.08-12 25.2-15.4-4.58-12.2-4.58-12.2-6.62 9.4-25.1 12.48-21.64 3.8-21.64 3.8z",
  fill: "#fff"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  d: "M316.08,267.7c-6.77,0-11.41-1.57-13.27-3.06-2.93-2.35-3.59-9.36-3.62-9.66a.5.5,0,0,1,.38-.53c.13,0,3.39-.81,21.68-3.86,18-3,24.7-12.18,24.77-12.27a.51.51,0,0,1,.41-.21h0a.5.5,0,0,1,.41.23c.6.92,5.8,9.14,4.64,12.63-1.23,3.68-14.12,13.49-25.58,15.73A51.38,51.38,0,0,1,316.08,267.7Zm-15.84-12.37c.19,1.54,1,6.76,3.2,8.53,2.5,2,10.51,4.16,22.27,1.86,11.56-2.26,23.83-12.07,24.83-15.07.79-2.38-2.44-8.39-4.16-11.17-1.78,2.13-8.92,9.43-25,12.1C306.56,254.06,301.58,255,300.24,255.33Z",
  fill: "#2e353a"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  d: "m373.5 186.3c-4.57-3-40.15-30.72-43.5-31.94s-10 0-10 0-20.62 2.52-24.94 4.26c-0.41 0.16-9.7 5.5-10 5.78-3.35 2.74-18 9.48-21.94 18-4.47 9.64 34.81 67.68 36.64 72.54s11.42 6.06 20.24 4.84 16.56-3 22.95-10.31a22.21 22.21 0 0 0 2.89-4.75 9.18 9.18 0 0 0 0.66-6.1c-2.28-9.5-8.1-36.89-11.94-55 6.4 4.13 19.71 12.52 27.45 15.48 10.34 4 18.25 1.22 18.25-2.13s-2.2-7.63-6.76-10.67z",
  fill: "#fff"
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  d: "m361.15 192.21a44.19 44.19 0 0 1-17.34-5.47s7.91-3.65 8.21-5.48-10.95-0.3-9.43-0.91 3.65-2.13 0-2.13a30.11 30.11 0 0 1-8.51-1.82l0.41 7.19c3.48 2.25 9 5.74 14.54 8.94a151.81 151.81 0 0 0 16.07 7.29s6.69-6.39-3.95-7.61z",
  fill: "#91C788"
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  d: "m279.61 174.73c6.73-1 25.49 9.7 25.49 9.7-10.31-7-19.33-13.56-25.5-16.52l-11.37 8-0.78 0.73c1.32-0.26 6.38-1.09 12.16-1.91z",
  fill: "#91C788"
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  d: "m361.15 192.21a44.19 44.19 0 0 1-17.34-5.47s7.91-3.65 8.21-5.48-10.95-0.3-9.43-0.91 3.65-2.13 0-2.13a30.11 30.11 0 0 1-8.51-1.82l0.41 7.19c3.48 2.25 9 5.74 14.54 8.94a151.81 151.81 0 0 0 16.07 7.29s6.69-6.39-3.95-7.61z",
  fill: "#fff",
  opacity: 0.5
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  d: "M319.93,259.77l1.13-.16c2.44-1.18,6.57-1.92,10.59-2.92,6.08-1.52-.61-1.52-10.65-6.69s-14-12.77-23.12-23.72-12.77-16.43-10.94-17.64-3.65-1.22-5.78-2.44,3-1.21,7.3-5.47-8.22.91-9.43.61,1.21-4.26,1.21-4.26l-8.82,9.12,21.29,36.5,1.22.91,1.4,2,4,8.6c.16.3.27.55.34.72C301.51,259.8,311.11,261,319.93,259.77Z",
  fill: "#fff",
  opacity: 0.5
});

var _ref49 = /*#__PURE__*/React.createElement("path", {
  d: "m279.61 174.73c6.73-1 25.49 9.7 25.49 9.7-10.31-7-19.33-13.56-25.5-16.52l-11.37 8-0.78 0.73c1.32-0.26 6.38-1.09 12.16-1.91z",
  fill: "#fff",
  opacity: 0.5
});

var _ref50 = /*#__PURE__*/React.createElement("path", {
  d: "M313.53,260.72c-6.74,0-12.81-1.61-14.31-5.61-.44-1.18-3.4-6-7.15-12.06-15.93-25.84-32.66-54-29.47-60.87,3-6.48,11.87-11.83,17.74-15.37a45,45,0,0,0,4.33-2.8c.36-.29,9.67-5.65,10.17-5.85,4.34-1.75,24.22-4.19,25.07-4.29.25-.05,6.83-1.23,10.26,0,2.22.81,17.43,12.32,29.65,21.57,6.62,5,12.33,9.34,13.95,10.42,5.1,3.4,6.92,7.94,6.92,11.06a3.5,3.5,0,0,1-1.76,2.82c-2.95,2-9.4,2.75-17.17-.22-5.43-2.08-14.59-7.21-26.53-14.88,4,19.05,9.49,44.71,11.68,53.83a9.69,9.69,0,0,1-.69,6.44,21.69,21.69,0,0,1-3,4.86c-6.68,7.63-14.81,9.31-23.25,10.47A47,47,0,0,1,313.53,260.72Zm12.4-106.4a39.35,39.35,0,0,0-5.87.53c-.24,0-20.63,2.53-24.85,4.23-.55.25-9.46,5.38-9.91,5.71a43.43,43.43,0,0,1-4.45,2.87c-5.76,3.48-14.46,8.74-17.34,15-3.24,7,18,41.41,29.41,59.92,4.07,6.6,6.76,11,7.24,12.23,1.77,4.72,11.45,5.65,19.7,4.51s16.19-2.77,22.64-10.14a21.34,21.34,0,0,0,2.82-4.64,8.69,8.69,0,0,0,.62-5.76c-2.24-9.32-7.88-35.87-11.94-55a.51.51,0,0,1,.21-.52.5.5,0,0,1,.55,0c12.38,8,21.84,13.33,27.36,15.43,7.38,2.83,13.6,2.16,16.24.34a2.65,2.65,0,0,0,1.33-2c0-2.86-1.7-7.05-6.47-10.23-1.65-1.1-7.37-5.43-14-10.45-11.53-8.72-27.31-20.67-29.39-21.43A12.14,12.14,0,0,0,325.93,154.32Z",
  fill: "#2e353a"
});

var _ref51 = /*#__PURE__*/React.createElement("path", {
  d: "M267.94,176.17s-3.65,4-5.07,5.85c-7.62,9.79-31.87,41.16-32.14,43.69s.88,4.23,6.81,6.51,45.6-37.47,45.6-37.47",
  fill: "#fff"
});

var _ref52 = /*#__PURE__*/React.createElement("path", {
  d: "M268,176.29l-.51.33c-.74.82-2.34,2.61-3.58,4.08l-18.42,24.16s-.57.64-1.47,1.7c-6.91,9.21-12.93,17.52-13.3,19,0,.05,0,.1,0,.14-.24,2.39.92,4.21,6.82,6.48,1.05.4,3.13-.5,5.86-2.25a11.68,11.68,0,0,1-3.91-1.56c-3.35-2.13-.61-4.26-.61-4.26s4.35,1.74,8.64,2.91c.89-.67,1.82-1.39,2.77-2.15a21.09,21.09,0,0,1-2.59-2c-3.65-3.34-6.69-6.69-6.69-6.69l27.88-38.91Z",
  fill: "#fff",
  opacity: 0.5
});

var _ref53 = /*#__PURE__*/React.createElement("path", {
  d: "M238,232.8a1.9,1.9,0,0,1-.66-.11c-5.52-2.13-7.46-4-7.13-7,.27-2.49,20.32-28.6,32.24-43.94,1.42-1.82,4.95-5.71,5.1-5.87a.5.5,0,1,1,.74.67s-3.66,4-5.05,5.82c-19.26,24.78-31.84,41.83-32,43.43-.23,2.13.76,3.79,6.5,6,4.13,1.59,29.21-21.48,45.06-37.37a.5.5,0,0,1,.71.71C279.54,199.06,245.66,232.8,238,232.8Z",
  fill: "#2e353a"
});

var _ref54 = /*#__PURE__*/React.createElement("path", {
  d: "m348.21 174.35-13.72 9.24c2-0.28 11.48-3.64 11.48-3.64",
  fill: "#fff"
});

var _ref55 = /*#__PURE__*/React.createElement("path", {
  d: "M334.49,184.09a.48.48,0,0,1-.46-.32.49.49,0,0,1,.18-.59l13.73-9.24a.49.49,0,0,1,.69.13.51.51,0,0,1-.14.7l-11.25,7.58c3.45-1.06,8.5-2.84,8.57-2.87a.5.5,0,0,1,.33,1c-.39.13-9.59,3.38-11.58,3.66Z",
  fill: "#2e353a"
});

var _ref56 = /*#__PURE__*/React.createElement("line", {
  x1: 347.65,
  x2: 350.73,
  y1: 179.67,
  y2: 179.11,
  fill: "#fff"
});

var _ref57 = /*#__PURE__*/React.createElement("path", {
  d: "M347.65,180.17a.51.51,0,0,1-.49-.41.5.5,0,0,1,.4-.58l3.08-.56a.51.51,0,0,1,.59.4.5.5,0,0,1-.41.59l-3.08.56Z",
  fill: "#2e353a"
});

var _ref58 = /*#__PURE__*/React.createElement("path", {
  d: "m246 216a14.57 14.57 0 0 0-6.17 1.17",
  fill: "#fff"
});

var _ref59 = /*#__PURE__*/React.createElement("path", {
  d: "M239.83,217.7a.5.5,0,0,1-.19-1,15,15,0,0,1,6.4-1.21.5.5,0,0,1,.46.54.51.51,0,0,1-.54.46,14,14,0,0,0-5.93,1.13A.48.48,0,0,1,239.83,217.7Z",
  fill: "#2e353a"
});

var _ref60 = /*#__PURE__*/React.createElement("path", {
  d: "m275.9 202.29s7.71-2.36 9.75-3.93",
  fill: "#fff"
});

var _ref61 = /*#__PURE__*/React.createElement("path", {
  d: "M275.9,202.79a.5.5,0,0,1-.14-1c.07,0,7.64-2.34,9.59-3.84a.5.5,0,0,1,.7.09.51.51,0,0,1-.09.7c-2.1,1.61-9.59,3.91-9.91,4A.39.39,0,0,1,275.9,202.79Z",
  fill: "#2e353a"
});

var _ref62 = /*#__PURE__*/React.createElement("path", {
  d: "m287.54 197.58s1.26-1.1 1.73-1.1",
  fill: "#fff"
});

var _ref63 = /*#__PURE__*/React.createElement("path", {
  d: "M287.54,198.08a.52.52,0,0,1-.38-.17.51.51,0,0,1,0-.71,4.55,4.55,0,0,1,2.06-1.22.5.5,0,0,1,.5.5.51.51,0,0,1-.5.5,5.63,5.63,0,0,0-1.4,1A.48.48,0,0,1,287.54,198.08Z",
  fill: "#2e353a"
});

var _ref64 = /*#__PURE__*/React.createElement("line", {
  x1: 334.49,
  x2: 333.24,
  y1: 183.59,
  y2: 170.74,
  fill: "#fff"
});

var _ref65 = /*#__PURE__*/React.createElement("path", {
  d: "M334.49,184.09a.51.51,0,0,1-.5-.45l-1.25-12.85a.5.5,0,1,1,1-.1L335,183.55a.49.49,0,0,1-.45.54Z",
  fill: "#2e353a"
});

var _ref66 = /*#__PURE__*/React.createElement("path", {
  d: "M230.7,225.84s-1.77,6.77,9.58,9.58c5.39,1.33,41.06,10,41.06,10s3.19-6.84,1.37-6.84S248,216.71,248,216.71",
  fill: "#fff"
});

var _ref67 = /*#__PURE__*/React.createElement("path", {
  d: "m236 233.93 41.36 10.56 1.1-2.62s-15.58-3.12-25.31-8-10.35-3.35-13.69-5.47-0.61-4.26-0.61-4.26 9.13 3.65 14 3.95-1.52-1.82-5.17-5.17c-1.51-1.38-2.91-2.77-4-3.91l-13 6.82s-1.26 4.91 5.32 8.1z",
  fill: "#91C788"
});

var _ref68 = /*#__PURE__*/React.createElement("path", {
  d: "m236 233.93 41.36 10.56 1.1-2.62s-15.58-3.12-25.31-8-10.35-3.35-13.69-5.47-0.61-4.26-0.61-4.26 9.13 3.65 14 3.95-1.52-1.82-5.17-5.17c-1.51-1.38-2.91-2.77-4-3.91l-13 6.82s-1.26 4.91 5.32 8.1z",
  fill: "#fff",
  opacity: 0.5
});

var _ref69 = /*#__PURE__*/React.createElement("path", {
  d: "M281.34,246h-.12s-35.67-8.71-41.06-10c-4.5-1.11-7.55-3-9.06-5.51a6.45,6.45,0,0,1-.88-4.68.51.51,0,0,1,.61-.36.5.5,0,0,1,.35.61h0a5.64,5.64,0,0,0,.8,3.94c1.37,2.3,4.21,4,8.42,5,5,1.25,36.72,9,40.66,9.94,1.23-2.72,2-5.36,1.65-5.77h0c-1.9,0-29.45-18.3-34.95-22a.51.51,0,0,1-.14-.7.49.49,0,0,1,.69-.13c12.95,8.63,32.81,21.56,34.42,21.81h0a1,1,0,0,1,.82.45c.83,1.31-1.14,5.77-1.77,7.11A.5.5,0,0,1,281.34,246Z",
  fill: "#2e353a"
});

var _ref70 = /*#__PURE__*/React.createElement("path", {
  d: "M282.71,238.61s11.71,5.48,12.62,7,3,9.42,3,11.86-.3,2.43-1.82,2.43-5.48-5.78-6.39-7-3-1.22-5.78-3a6.72,6.72,0,0,1-3-4.41Z",
  fill: "#fff"
});

var _ref71 = /*#__PURE__*/React.createElement("path", {
  d: "M296.55,260.4c-1.31,0-3.47-2.61-6.31-6.53-.2-.28-.36-.51-.48-.66a4.42,4.42,0,0,0-2.07-1.16,17.21,17.21,0,0,1-3.59-1.77,7.25,7.25,0,0,1-3.26-4.77.76.76,0,0,1,0-.15l1.37-6.85a.52.52,0,0,1,.26-.35.49.49,0,0,1,.44,0c2,.92,11.9,5.62,12.84,7.19s3.11,9.61,3.11,12.12S298.4,260.4,296.55,260.4Zm-14.7-14.93a6.3,6.3,0,0,0,2.81,4,16.23,16.23,0,0,0,3.39,1.66,5.21,5.21,0,0,1,2.51,1.5c.12.15.29.38.49.67,3.66,5.06,5,6.12,5.5,6.12,1.32,0,1.32,0,1.32-1.93,0-2.36-2.08-10.13-3-11.61-.58-1-7.33-4.4-11.83-6.53Z",
  fill: "#2e353a"
});

var _ref72 = /*#__PURE__*/React.createElement("line", {
  x1: 277.71,
  x2: 279.53,
  y1: 244.28,
  y2: 238.63,
  fill: "#fff"
});

var _ref73 = /*#__PURE__*/React.createElement("path", {
  d: "M277.71,244.78a.4.4,0,0,1-.15,0,.49.49,0,0,1-.32-.63l1.82-5.65a.5.5,0,1,1,.95.31l-1.82,5.65A.51.51,0,0,1,277.71,244.78Z",
  fill: "#2e353a"
});

var _ref74 = /*#__PURE__*/React.createElement("path", {
  d: "M366.5,196s-3,10.34-4.26,16.42-9.73,30.42-9.73,30.42l7.3,4.56S375.93,214,379,206.68s2.13-12.78-.91-15.82",
  fill: "#fff"
});

var _ref75 = /*#__PURE__*/React.createElement("path", {
  d: "M359.81,247.93a.5.5,0,0,1-.26-.08l-7.3-4.56a.5.5,0,0,1-.21-.59c.08-.24,8.52-24.37,9.71-30.34S366,196,366,195.89a.5.5,0,0,1,1,.28c0,.1-3.05,10.39-4.25,16.38-1.14,5.71-8.49,26.89-9.62,30.11l6.49,4.05c2-4.21,16.11-33.51,18.91-40.23,2.7-6.49,2.41-12-.8-15.27a.49.49,0,0,1,.7-.7c3.52,3.51,3.89,9.48,1,16.36-3,7.23-19,40.44-19.17,40.78a.48.48,0,0,1-.31.26Z",
  fill: "#2e353a"
});

var _ref76 = /*#__PURE__*/React.createElement("path", {
  d: "M353.89,239.36c.55,0,7.48,3.82,7.48,3.82",
  fill: "#2e353a"
});

var _ref77 = /*#__PURE__*/React.createElement("path", {
  d: "m305.93 184.43c-1.68-0.28-10.65-6.16-16.81-10.92s-9.52-5.6-9.52-5.6l-4.2 2.8a8.1 8.1 0 0 1 0.56-6.16c1.68-3.08 7.56-6.16 13.44-8.4s12.6-4.15 16.81-4.15 5.32 1.68 5.32 3.92 0 9.24-1.4 14.56-4.2 13.95-4.2 13.95z",
  fill: "#fff"
});

var _ref78 = /*#__PURE__*/React.createElement("path", {
  d: "m303.29 155.23s-2.59 7.76-5.18 10.09a38.76 38.76 0 0 1-6.46 4.39s-1.55-5.43-5.43-5.43-9.83 2.59-9.83 2.59 0-2.07 4.91-4.66l4.92-2.58 11.38-4.4z",
  fill: "#fff",
  opacity: 0.5
});

var _ref79 = /*#__PURE__*/React.createElement("path", {
  d: "M305.93,184.93h-.09c-1.86-.31-11.07-6.42-17-11-5.15-4-8.33-5.19-9.14-5.45l-4,2.67a.56.56,0,0,1-.44.06.5.5,0,0,1-.31-.31,8.53,8.53,0,0,1,.59-6.57c2-3.74,9.46-7,13.71-8.63,3.34-1.27,11.68-4.23,17-4.23,3.91,0,5.82,1.44,5.82,4.42,0,2.3,0,9.31-1.42,14.69s-4.18,13.94-4.21,14A.49.49,0,0,1,305.93,184.93ZM279.6,167.41l.12,0c.14,0,3.54.92,9.71,5.69,5.79,4.47,13.86,9.79,16.17,10.7.6-1.88,2.85-9,4-13.52,1.39-5.25,1.39-12.16,1.39-14.43,0-1.69-.57-3.42-4.82-3.42-3.62,0-9.68,1.52-16.63,4.17s-11.8,5.64-13.18,8.17a7.56,7.56,0,0,0-.7,5.12l3.62-2.41A.49.49,0,0,1,279.6,167.41Z",
  fill: "#2e353a"
});

var _ref80 = /*#__PURE__*/React.createElement("path", {
  d: "m281 148.89a28.69 28.69 0 0 1 6.69 12.77c1.82 7.91 13.26 17.21 16 17.21s2.55-13.56 1.64-17.51-4.56-14.6-4.56-14.6-14.56-7-19.77 2.13z",
  fill: "#fff"
});

var _ref81 = /*#__PURE__*/React.createElement("path", {
  d: "M303.73,179.37c-2.94,0-14.64-9.56-16.49-17.6a28.44,28.44,0,0,0-6.56-12.53.5.5,0,0,1-.08-.6c5.34-9.42,20.27-2.41,20.42-2.33a.5.5,0,0,1,.26.29c.15.43,3.67,10.71,4.58,14.65.79,3.46,1.16,14.83-.94,17.48A1.51,1.51,0,0,1,303.73,179.37Zm-22.07-30.55a29.14,29.14,0,0,1,6.55,12.73c1.82,7.85,13.19,16.82,15.52,16.82,0,0,.19,0,.4-.27,1.7-2.13,1.59-13,.75-16.63s-4-12.85-4.48-14.35C298.73,146.38,286.38,141.21,281.66,148.82Z",
  fill: "#2e353a"
});

var _ref82 = /*#__PURE__*/React.createElement("path", {
  d: "m303.29 155.23s-2.59 7.76-5.18 10.09a38.76 38.76 0 0 1-6.46 4.39s-1.55-5.43-5.43-5.43-9.83 2.59-9.83 2.59 0-2.07 4.91-4.66l4.92-2.58 11.38-4.4z",
  fill: "#fff",
  opacity: 0.5
});

var _ref83 = /*#__PURE__*/React.createElement("path", {
  d: "m281 148.89a28.69 28.69 0 0 1 6.69 12.77c1.82 7.91 13.26 17.21 16 17.21s2.55-13.56 1.64-17.51-4.56-14.6-4.56-14.6-14.56-7-19.77 2.13z",
  fill: "#fff"
});

var _ref84 = /*#__PURE__*/React.createElement("path", {
  d: "M303.73,179.37c-2.94,0-14.64-9.56-16.49-17.6a28.44,28.44,0,0,0-6.56-12.53.5.5,0,0,1-.08-.6c5.34-9.42,20.27-2.41,20.42-2.33a.5.5,0,0,1,.26.29c.15.43,3.67,10.71,4.58,14.65.79,3.46,1.16,14.83-.94,17.48A1.51,1.51,0,0,1,303.73,179.37Zm-22.07-30.55a29.14,29.14,0,0,1,6.55,12.73c1.82,7.85,13.19,16.82,15.52,16.82,0,0,.19,0,.4-.27,1.7-2.13,1.59-13,.75-16.63s-4-12.85-4.48-14.35C298.73,146.38,286.38,141.21,281.66,148.82Z",
  fill: "#2e353a"
});

var _ref85 = /*#__PURE__*/React.createElement("path", {
  d: "m271.39 134.23a106.24 106.24 0 0 0 7.93 16.84c4.62 7.59 13.54 11.89 18.49 9.91s8.32-8.37 7-18.27c-0.29-2.18-2.19-3.07-2.8-5-2.19-7-4.42-13.75-5.19-16.32-1-3.31-8.92-6.61-17.17-4.3s-9.58 9.21-8.26 17.14z",
  fill: "#fff"
});

var _ref86 = /*#__PURE__*/React.createElement("path", {
  d: "M298.8,128.17s-3,2.23-9.74.94-11.38-1-11.12.78.78,4.13.78,4.13-8.09-7-.76-8.86c5.28-1.37,8.33.71,9.62,1S298.8,128.17,298.8,128.17Z",
  fill: "#91C788"
});

var _ref87 = /*#__PURE__*/React.createElement("path", {
  d: "M298.8,128.17s-3,2.23-9.74.94-11.38-1-11.12.78.78,4.13.78,4.13-8.09-7-.76-8.86c5.28-1.37,8.33.71,9.62,1S298.8,128.17,298.8,128.17Z",
  fill: "#fff",
  opacity: 0.5
});

var _ref88 = /*#__PURE__*/React.createElement("path", {
  d: "m295.05 162c-5.37 0-12.36-4.39-16.16-10.64a106.79 106.79 0 0 1-8-16.94 0.19 0.19 0 0 1 0-0.08c-1.65-9.85 1.17-15.66 8.61-17.74 8.63-2.42 16.74 1.14 17.79 4.63 0.36 1.21 1 3.33 1.89 6 1 3 2.13 6.63 3.29 10.35a6.31 6.31 0 0 0 1.26 2 6 6 0 0 1 1.56 3.07c1.48 11.11-2.8 17-7.3 18.8a7.89 7.89 0 0 1-2.94 0.55zm-23.17-27.9a106.38 106.38 0 0 0 7.86 16.71c4.65 7.63 13.44 11.48 17.89 9.7 4.15-1.66 8.09-7.19 6.68-17.74a5.16 5.16 0 0 0-1.31-2.57 7 7 0 0 1-1.43-2.39c-1.16-3.71-2.33-7.35-3.29-10.34-0.85-2.64-1.53-4.77-1.9-6-0.84-2.78-8.23-6.29-16.56-4-6.88 1.98-9.47 7.4-7.94 16.63z",
  fill: "#2e353a"
});

var _ref89 = /*#__PURE__*/React.createElement("path", {
  d: "M277.34,145.12s-5.29-2.31-5.62,0,2,4,4.29,5a3.28,3.28,0,0,0,3.64-.33",
  fill: "#fff"
});

var _ref90 = /*#__PURE__*/React.createElement("path", {
  d: "M277.68,151a4.69,4.69,0,0,1-1.86-.41c-3.27-1.4-4.9-3.35-4.59-5.49a1.51,1.51,0,0,1,.79-1.17c1.59-.89,5.12.61,5.52.79a.5.5,0,0,1-.41.91c-1.32-.58-3.75-1.31-4.63-.83a.54.54,0,0,0-.28.44c-.32,2.23,2.36,3.73,4,4.43a2.82,2.82,0,0,0,3.09-.23.5.5,0,0,1,.7.71A3.39,3.39,0,0,1,277.68,151Z",
  fill: "#2e353a"
});

var _ref91 = /*#__PURE__*/React.createElement("path", {
  d: "M298.93,132.06s-5.89-1.4-3.37,6.45c.5,1.55,3.93,3.36,3.93,3.36s-.28,2.52-1.68,2.8",
  fill: "#fff"
});

var _ref92 = /*#__PURE__*/React.createElement("path", {
  d: "M297.8,145.17a.51.51,0,0,1-.49-.4.5.5,0,0,1,.4-.59c.72-.15,1.09-1.34,1.23-2-.92-.52-3.38-2-3.85-3.48-.94-2.92-.86-5,.23-6.18,1.34-1.45,3.62-.92,3.72-.9a.5.5,0,0,1,.37.6.49.49,0,0,1-.6.37s-1.82-.41-2.76.61-.82,2.68,0,5.19c.32,1,2.43,2.41,3.68,3.07a.52.52,0,0,1,.26.5c0,.3-.37,2.9-2.08,3.24Z",
  fill: "#2e353a"
});

var _ref93 = /*#__PURE__*/React.createElement("path", {
  d: "M294.72,150.27s-4.2.84-5.88-1.12",
  fill: "#fff"
});

var _ref94 = /*#__PURE__*/React.createElement("path", {
  d: "M292.71,151a5.59,5.59,0,0,1-4.25-1.48.5.5,0,0,1,.76-.65c1.47,1.72,5.37,1,5.41,1a.48.48,0,0,1,.58.39.5.5,0,0,1-.39.59A12.28,12.28,0,0,1,292.71,151Z",
  fill: "#2e353a"
});

var _ref95 = /*#__PURE__*/React.createElement("path", {
  d: "M288.56,137.11s-3.08-1.12-4.76.28a5.59,5.59,0,0,0-2,2.52",
  fill: "#fff"
});

var _ref96 = /*#__PURE__*/React.createElement("path", {
  d: "M281.84,140.4h-.12a.5.5,0,0,1-.36-.61,6.06,6.06,0,0,1,2.12-2.78c1.88-1.56,5.12-.41,5.25-.36a.49.49,0,0,1,.3.64.5.5,0,0,1-.64.3s-2.83-1-4.27.19a5.34,5.34,0,0,0-1.79,2.26A.51.51,0,0,1,281.84,140.4Z",
  fill: "#2e353a"
});

var _ref97 = /*#__PURE__*/React.createElement("path", {
  d: "M288.48,141.9c.4.93.32,1.85-.18,2.06s-1.22-.36-1.62-1.29-.31-1.84.19-2.06S288.09,141,288.48,141.9Z",
  fill: "#2e353a"
});

var _ref98 = /*#__PURE__*/React.createElement("path", {
  d: "M298.55,137c.4.92.31,1.84-.18,2.06s-1.23-.37-1.62-1.29-.32-1.85.18-2.06S298.15,136.08,298.55,137Z",
  fill: "#2e353a"
});

var _ref99 = /*#__PURE__*/React.createElement("path", {
  d: "M275.87,146.45s3.34-2.43,2.73-4.56-1.82-2.13-.6-3.34,2.12-1.83,1.82-3.65-5.17-4.87-3.65-6.69.91-4,13.38-.92,20.38-1.82,16.73-6.38-6.69-5.17-6.69-5.17,7-3,1.22-6.09-18.86-3-26.16,2.74S268.87,123,268.87,123s-3.95.61-4.26,6.7S275.87,146.45,275.87,146.45Z",
  fill: "#2e353a"
});

var _ref100 = /*#__PURE__*/React.createElement("path", {
  d: "M295.77,126.08a22.49,22.49,0,0,1-7.73-1.72,18.43,18.43,0,0,0-6.06-1.44c-4.83,0-5.83,2.74-5.87,2.86a.33.33,0,0,1-.43.21.34.34,0,0,1-.22-.43c.05-.13,1.17-3.33,6.52-3.33a18.72,18.72,0,0,1,6.29,1.49c3.11,1.11,6.34,2.26,10.4,1.36,2.2-.49,3.49-1.28,3.81-2.33.42-1.35-.88-2.76-.89-2.78a.34.34,0,0,1,0-.48.36.36,0,0,1,.49,0c.06.07,1.58,1.72,1.05,3.45-.41,1.31-1.86,2.25-4.32,2.8A14.42,14.42,0,0,1,295.77,126.08Z",
  fill: "#fff"
});

var _ref101 = /*#__PURE__*/React.createElement("path", {
  d: "M273.46,125.24h0a.35.35,0,0,1-.32-.37c0-.07.59-6.67,6.44-8.15,3.45-.87,7.44-.22,10.65.3,2,.33,3.79.62,4.54.33a.35.35,0,0,1,.24.65c-.92.34-2.67.06-4.89-.3-3.15-.52-7.07-1.15-10.37-.32-5.38,1.37-5.92,7.48-5.93,7.54A.34.34,0,0,1,273.46,125.24Z",
  fill: "#fff"
});

var _ref102 = /*#__PURE__*/React.createElement("path", {
  d: "M269.59,135.56a.35.35,0,0,1-.19-.06,7.05,7.05,0,0,1-2.47-6.24c.28-4.4,3.66-4.45,3.7-4.45a.35.35,0,0,1,0,.69c-.12,0-2.78.06-3,3.8a6.35,6.35,0,0,0,2.17,5.64.33.33,0,0,1,.08.47A.32.32,0,0,1,269.59,135.56Z",
  fill: "#fff"
});

var _ref103 = /*#__PURE__*/React.createElement("path", {
  d: "M271.66,132.72a.34.34,0,0,1-.31-.2,3.64,3.64,0,0,1-.21-3,4.15,4.15,0,0,1,2.2-2.1.33.33,0,0,1,.44.19.34.34,0,0,1-.19.44,3.57,3.57,0,0,0-1.82,1.73,3,3,0,0,0,.2,2.45.35.35,0,0,1-.17.46A.35.35,0,0,1,271.66,132.72Z",
  fill: "#fff"
});

var _ref104 = /*#__PURE__*/React.createElement("path", {
  d: "M272.43,138.14a.35.35,0,0,1-.28-.15l-1.29-1.8a.34.34,0,0,1,.56-.4l1.29,1.81a.34.34,0,0,1-.08.47A.31.31,0,0,1,272.43,138.14Z",
  fill: "#fff"
});

function SvgEmtyprofile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "30 80 500 500",
    width: 350,
    height: 350,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, /*#__PURE__*/React.createElement("path", {
    d: "M319.93,259.77l1.13-.16c2.44-1.18,6.57-1.92,10.59-2.92,6.08-1.52-.61-1.52-10.65-6.69s-14-12.77-23.12-23.72-12.77-16.43-10.94-17.64-3.65-1.22-5.78-2.44,3-1.21,7.3-5.47-8.22.91-9.43.61,1.21-4.26,1.21-4.26l-8.82,9.12,21.29,36.5,1.22.91,1.4,2,4,8.6c.16.3.27.55.34.72C301.51,259.8,311.11,261,319.93,259.77Z",
    fill: "#91C788",
    style: {
      mixBlendMode: "multiply"
    }
  }), _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, /*#__PURE__*/React.createElement("path", {
    d: "M268,176.29l-.51.33c-.74.82-2.34,2.61-3.58,4.08l-18.42,24.16s-.57.64-1.47,1.7c-6.91,9.21-12.93,17.52-13.3,19,0,.05,0,.1,0,.14-.24,2.39.92,4.21,6.82,6.48,1.05.4,3.13-.5,5.86-2.25a11.68,11.68,0,0,1-3.91-1.56c-3.35-2.13-.61-4.26-.61-4.26s4.35,1.74,8.64,2.91c.89-.67,1.82-1.39,2.77-2.15a21.09,21.09,0,0,1-2.59-2c-3.65-3.34-6.69-6.69-6.69-6.69l27.88-38.91Z",
    fill: "#91C788",
    opacity: 0.8,
    style: {
      mixBlendMode: "multiply"
    }
  }), _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70, _ref71, _ref72, _ref73, _ref74, _ref75, _ref76, _ref77, /*#__PURE__*/React.createElement("path", {
    d: "m303.29 155.23s-2.59 7.76-5.18 10.09a38.76 38.76 0 0 1-6.46 4.39s-1.55-5.43-5.43-5.43-9.83 2.59-9.83 2.59 0-2.07 4.91-4.66l4.92-2.58 11.38-4.4z",
    fill: "#91C788",
    style: {
      mixBlendMode: "multiply"
    }
  }), _ref78, _ref79, _ref80, _ref81, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#freepik--clip-path-2--inject-1--inject-1--inject-2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m303.29 155.23s-2.59 7.76-5.18 10.09a38.76 38.76 0 0 1-6.46 4.39s-1.55-5.43-5.43-5.43-9.83 2.59-9.83 2.59 0-2.07 4.91-4.66l4.92-2.58 11.38-4.4z",
    fill: "#91C788",
    style: {
      mixBlendMode: "multiply"
    }
  }), _ref82, _ref83, _ref84), _ref85, _ref86, _ref87, _ref88, _ref89, _ref90, _ref91, _ref92, _ref93, _ref94, _ref95, _ref96, _ref97, _ref98, _ref99, _ref100, _ref101, _ref102, _ref103, _ref104);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmtyprofile);
export default __webpack_public_path__ + "static/media/emtyprofile.88bbe975.svg";
export { ForwardRef as ReactComponent };